var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LoadingLayer'),_c('VerticalNav'),_c('Navbar'),_c('Home'),_c('About'),_c('Interest'),_c('InterestContent'),_c('Case'),_c('CaseContent'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }